<template>
  <div
    class="block-wrap block-specification"
    style="padding:10px">
    <div
      v-for="(s, sindex) in specifications"
      :key="s.nameKey">
      <div class="title-bg">
        规格名：
        <template>
          <el-input :disabled="disabledSpName" style="width:140px" v-model="s.name" @keyup.enter.native="(e) => nameEnter(sindex)" :maxlength="20"></el-input>
        </template>
        <el-button
          style="float: right"
          v-show="showDelSpNameBtn" type="link" @click="removeSpName(sindex)">删除</el-button>
      </div>
      <div v-if="isPlatform && showAddSkuTips && sindex === 0" class="add-sku-tips">
        <div>
          如需添加新的规格值,请至<el-link @click="changeToBase">【基础资料】</el-link>进行添加
        </div>
        <span @click="handleNoTips" class="tips-btn">不再提示</span>
      </div>
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left:10px;">规格值：</div>
        <vue-draggable class="specification-value-flex" v-model="specifications[sindex].values" handle=".drag-icon-wrap" :group="{ name: s.nameKey, pull: 'clone', put: false }" :animation="500">
          <div
            v-for="(v, vi) in specifications[sindex].values"
            :key="v.valueKey"
            class="specification-value-flex_item">
            <div class="del-input-wrap">
              <el-select
                v-if="s.isSelect"
                :ref="`${sindex}-${vi}`"
                :disabled="disabledSpValue"
                @change="(e) => selectedHandle(sindex, vi, e)" class="specification-value-flex_input"
                v-model="v.value">
                <el-option
                  v-for="op in s.options"
                  :key="op.value"
                  :label="op.displayName"
                  :value="op.displayName"
                  :disabled="s.values.findIndex(_v => _v.value === op.displayName) > -1"></el-option>
              </el-select>
              <el-input
                v-else
                :ref="`${sindex}-${vi}`"
                :disabled="disabledSpValue"
                @blur="(e) => blurHandle(sindex, vi, e)" class="specification-value-flex_input"
                @keyup.enter.native="(e) => valueEnter(sindex, vi)"
                @input="(e) => valueInput(v)"
                v-model="v.value"></el-input>
              <el-checkbox
                style="margin-left: 8px"
                v-model="v.checked"
                @change="onChangeCheckbox"
                :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1"></el-checkbox>
              <drag-item-content></drag-item-content>
            </div>
            <div v-if="remarkKey" class="remarkWrap">
              <el-input
                class="input-remark"
                :ref="`${sindex}-${vi}-remark`"
                placeholder="属性备注"
                @input="remarkInput"
                v-model="v[remarkKey]"></el-input>
            </div>
            <div v-if="sindex === 0 && !noSpPic" class="specification-value-flex_img">
              <ImgUpload
                :width="80"
                :height="80"
                :file="v.imageUrl"
                @upload-success="(url) => imageUploadSuccess(url, v)"
                @del="() => imageUploadDel(v)"
                :limitSuffix="imgLimitSuffix"
                :isSingle="true"
              />
            </div>
          </div>
        </vue-draggable>
      </div>
    </div>
    <div v-show="showAddSpNameBtn" class="title-bg">
      <el-button @click="addSpName">添加商品规格</el-button>
    </div>
  </div>
</template>

<script>
import FormItemSpecification from "@/components/prod/center/components/FormItemSpecification/FormItemSpecification.vue"
export default {
  extends: FormItemSpecification,
  methods: {
    // select类型选择
    selectedHandle(sindex, vi, v) {
      this.blurHandle(sindex, vi, {target: {value: v}}, {isSelect: true})
    },
    // 规格值输入
    blurHandle(sindex, vi, e, {isSelect} = {}) {
      const _value = e.target.value
      if (!_value) return this.$message.error('请填写规格值')
      const values = this.specifications[sindex].values
      let isSame = false
      values.forEach((item, i) => {
        if (vi !== i && item.value === e.target.value) {
          isSame = true
        }
      })
      if (isSame) { 
        this.$message.error(`请勿${isSelect ? '选择' : '输入'}相同规格值`)
      }
    }
  }
}
</script>
